import { forwardRef } from 'react';
import MaterialModal, { ModalProps } from '@mui/material/Modal';

export const Modal = forwardRef<HTMLDivElement, ModalProps>((props, ref) => {
    return (
        <MaterialModal ref={ref} data-testid={'Modal-container'} {...props} />
    );
});

export default Modal;
